const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/home",
    exact: true,
    component: "Home",
  },
  {
    path: "/child-safety",
    exact: true,
    component: "ChildSafety",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: "/links",
    exact: true,
    component: "Links",
  },
  {
    path: "/panoramic",
    exact: true,
    component: "Panoramic",
  },
];

export default routes;
